var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitefiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 98,
    viewBox: "0 0 84 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.2328,
    y: 22.82,
    width: 45.3243,
    height: 63.7282,
    rx: 7,
    transform: "rotate(2.5 28.2328 22.82)",
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.443678,
    y: 18.5301,
    width: 48.8243,
    height: 67.2282,
    rx: 8.75,
    transform: "rotate(-7.5 0.443678 18.5301)",
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32937 27.1054C1.75266 22.7249 4.83624 18.7063 9.21671 18.1296L40.2731 14.041C44.6535 13.4643 48.6721 16.5478 49.2488 20.9283L50.1779 27.9849L3.25839 34.162L2.32937 27.1054Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.4102,
    y: 14.9688,
    width: 1.97185,
    height: 6.57282,
    rx: 0.985924,
    transform: "rotate(82.5 58.4102 14.9688)",
    fill: "#6F6FF1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4062,
    y: 4.08203,
    width: 1.97185,
    height: 6.57282,
    rx: 0.985924,
    transform: "rotate(-7.5 40.4062 4.08203)",
    fill: "#6F6FF1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 51.9609,
    y: 5.875,
    width: 1.97185,
    height: 6.57282,
    rx: 0.985924,
    transform: "rotate(37.5 51.9609 5.875)",
    fill: "#6F6FF1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.16797,
    y: 36.1699,
    width: 38.1224,
    height: 2.62913,
    rx: 1.31456,
    transform: "rotate(-7.5 8.16797 36.1699)",
    fill: "#D6D6D6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.88281,
    y: 49.2031,
    width: 30.7692,
    height: 2.62913,
    rx: 1.31456,
    transform: "rotate(-7.5 9.88281 49.2031)",
    fill: "#D6D6D6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.85547,
    y: 41.3828,
    width: 13.8029,
    height: 2.62913,
    rx: 1.31456,
    transform: "rotate(-7.5 8.85547 41.3828)",
    fill: "#E6E6E6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5703,
    y: 54.416,
    width: 13.8029,
    height: 2.62913,
    rx: 1.31456,
    transform: "rotate(-7.5 10.5703 54.416)",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitefiles);
export default __webpack_public_path__ + "static/media/whitefiles.061bbd6195f3c4ce32889e369e206712.svg";
export { ForwardRef as ReactComponent };